export type RingArc = { start: number; length: number };

/** Where each state's arc sits on the ring, a small gap parting neighbours; null where the state is empty. */
export const ringArcs = (counts: number[], circ: number, gap = 1.6): (RingArc | null)[] => {
  const total = counts.reduce((sum, count) => sum + count, 0) || 1;
  const parted = counts.filter(count => count > 0).length > 1 ? gap : 0;
  let offset = 0;
  return counts.map(count => {
    if (count <= 0) return null;
    const size = (count / total) * circ;
    // Never more than half the slot, so a tiny state keeps a visible arc inside its own slot.
    const own = Math.min(parted, size / 2);
    const arc = { start: offset + own / 2, length: size - own };
    offset += size;
    return arc;
  });
};
